import { AUTOPLAY, PLAYBACK_RATE, PLAYBACK_RATES } from '@/stores/video_settings/config';
import { MENU } from '@/stores/video_settings/config';

const W_FULL = 'w-full';
const VISIBLE = 'visible';
export const SETTINGS_OPEN = 'settings-open';

export class VideoSettings {
    isOpen = false;

    showAutoplayOption = true;

    private selectedMenu: Menu = MENU.SETTINGS;

    private selectedRate: PlaybackRates = PLAYBACK_RATES.normal;

    private autoplayEnabled = AUTOPLAY.DISABLED;

    constructor() {
        this.init();
    }

    init() {
        this.isOpen = false;
        this.selectedMenu = MENU.SETTINGS;
        this.selectedRate = (Number(localStorage.getItem(PLAYBACK_RATE)) as PlaybackRates) || PLAYBACK_RATES.normal;

        this.setInitialAutoplay();
    }

    setInitialAutoplay() {
        const autoplay = localStorage.getItem(AUTOPLAY.NAME);

        if (autoplay === null) {
            return this.setAutoplayEnabled(AUTOPLAY.DISABLED);
        }

        this.autoplayEnabled = autoplay === AUTOPLAY.ENABLED.toString();
    }

    switchMenuItem(menuItem: Menu) {
        this.selectedMenu = menuItem;
        document.querySelectorAll('.submenu').forEach(el => el.classList.remove(VISIBLE));
        const settingsMainMenu = document.getElementById('settings-main-menu');
        if (settingsMainMenu) {
            settingsMainMenu.querySelectorAll('div').forEach(div => div.classList.remove(W_FULL));
        }
        if (menuItem === MENU.SETTINGS) {
            const mainSettings = document.getElementById('main-settings');
            if (mainSettings) mainSettings.classList.add(W_FULL);
        } else {
            const mainMenu = document.getElementById(`main-${menuItem.toLowerCase()}`);
            if (mainMenu) mainMenu.classList.add(W_FULL);
        }
        if (menuItem !== MENU.SETTINGS) {
            const submenu = document.getElementById(`${menuItem.toLowerCase()}-menu`);
            if (submenu) submenu.classList.add(VISIBLE);
        }
    }

    toggleSettings() {
        this.isOpen = !this.isOpen;
        window.main_player.toggleClass(SETTINGS_OPEN, this.isOpen);
    }

    closeSettings() {
        this.isOpen = false;
        window.main_player.toggleClass(SETTINGS_OPEN, false);
    }

    setPlaybackRate(rate: PlaybackRates) {
        window.main_player.playbackRate(rate);
        localStorage.setItem(PLAYBACK_RATE, rate.toString());
        this.selectedRate = rate;
    }

    setAutoplayEnabled(isEnabled: boolean) {
        this.autoplayEnabled = isEnabled;
        localStorage.setItem(AUTOPLAY.NAME, isEnabled.toString());
        window.main_player.autoplay(isEnabled);
    }

    getSelectedMenu(): Menu {
        return this.selectedMenu;
    }

    getSelectedRate(): PlaybackRates {
        return this.selectedRate;
    }

    getAutoplayEnabled(): boolean {
        return this.autoplayEnabled;
    }

    getIsOpen(): boolean {
        return this.isOpen;
    }
}
